import createStore from "astrid-helpers/src/createStore";
export const [getSize, setSize, useSize, onSize] = createStore(0);
//# sourceMappingURL=size.js.map